import { ArrowUp, MessageSquareHeart } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="text-center p-[2rem] bg-khamco-ribbon text-white flex justify-between items-center flex-wrap gap-[1rem]">
      <h4 className="font-minimoBold">
        {now.toLocaleDateString("en-US", {
          dateStyle: "full",
        })}{" "}
        {now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })}
      </h4>
      <Link
        to="/feedback"
        className="inline-flex items-center gap-1.5 text-white no-underline hover:underline text-sm font-medium"
      >
        <MessageSquareHeart size={16} /> {t("Feedback & Bug Reports")}
      </Link>
      <button
        className="bg-white text-khamco-primary p-3 text-lg rounded-full transition-all hover:scale-110"
        title={t("Scroll up")}
        onClick={() => window.scrollTo(0, 0)}
      >
        <ArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
